// Filled by vite.config.ts at build/dev start; absent under Vitest.
declare const __PUBLIC_ASSET_HASHES__: Record<string, string> | undefined;

/**
 * URL of a file under public/ with its content hash as `?v=`, so a changed
 * file gets a new URL and bypasses whatever the browser cached before.
 * Unknown paths (or no build-time hashes) come back unchanged.
 */
export function versionedPublicUrl(
  path: string,
  hashes: Record<string, string> | undefined = typeof __PUBLIC_ASSET_HASHES__ === "undefined"
    ? undefined
    : __PUBLIC_ASSET_HASHES__,
): string {
  const v = hashes?.[path];
  return v ? `${path}?v=${v}` : path;
}
